import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, Skeleton } from '@mui/material';

export const LoadingScreen = () => {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden'
      }}
    >
      {/* Main Content Area */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Navbar Skeleton Placeholder */}
        <Box
          sx={{
            height: 64,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            display: 'flex',
            alignItems: 'center',
            px: 3,
            flexShrink: 0
          }}
        >
          <Skeleton variant="text" width={150} height={24} />
          <Box sx={{ flexGrow: 1 }} />
          <Skeleton variant="circular" width={36} height={36} />
        </Box>

        {/* Content Body Skeleton */}
        <Box sx={{ p: 4, flexGrow: 1, overflow: 'hidden' }}>
          <Box sx={{ mb: 4 }}>
            <Skeleton variant="text" width={300} height={48} />
            <Skeleton variant="text" width={200} height={24} sx={{ mt: 1 }} />
          </Box>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[...Array(3)].map((_, i) => (
              <div key={i}>
                <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 1 }} animation="wave" />
              </div>
            ))}
          </div>

          <Box sx={{ mt: 5 }}>
            <Skeleton variant="rectangular" height={40} sx={{ mb: 2, borderRadius: 0.5 }} animation="wave" />
            {[...Array(6)].map((_, i) => (
              <Box key={i} sx={{ display: 'flex', gap: 2, mb: 1 }}>
                <Skeleton variant="text" width="20%" height={32} />
                <Skeleton variant="text" width="30%" height={32} />
                <Skeleton variant="text" width="25%" height={32} />
                <Skeleton variant="text" width="25%" height={32} />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
